export default "__VITE_ASSET__BiFQTr7Z__"